export function imgUrl(img) {
  if (!img || !img.host || !img.path) return null
  const url = `${img.host}/${img.path}`
  return url.replace(/([^:])\/\//i, '$1/')
}
